import moment from 'moment';

export function findLowerAndUpperLimit(limits = []) {
  let lowerLimit;
  let upperLimit;
  limits.forEach(({ eddLower, eddUpper }) => {
    if (eddLower) {
      const eddLowerDate = moment(eddLower);
      if (lowerLimit) {
        if (lowerLimit > eddLowerDate) {
          lowerLimit = eddLowerDate;
        }
      } else {
        lowerLimit = eddLowerDate;
      }
    }
    if (eddUpper) {
      const eddUpperDate = moment(eddUpper);
      if (upperLimit) {
        if (upperLimit < eddUpperDate) {
          if (!lowerLimit) {
            lowerLimit = upperLimit;
          }
          if (lowerLimit && lowerLimit > upperLimit) {
            lowerLimit = upperLimit;
          }
          upperLimit = eddUpperDate;
        } else if (upperLimit > eddUpperDate && lowerLimit > eddUpperDate && lowerLimit) {
          lowerLimit = eddUpperDate;
        } else if (!lowerLimit && upperLimit > eddUpperDate) {
          lowerLimit = eddUpperDate;
        }
      } else {
        upperLimit = eddUpperDate;
      }
    }
  });
  return {
    lowerLimit,
    upperLimit
  };
}
